import store from '../../store'
export default function statusActive({next, router}) {
        if (store.getters["user/isLoggedIn"] && 
            store.getters["user/status"].status === 2 &&
        store.getters["user/user"].verificationCode === null) {
        return router.push({name: "completeregistration"});
    }
    return next();
}